import { NgModule } from '@angular/core';
import { ContactComponent } from './contact.component';
import { BlacklistComponent } from './blacklist/blacklist.component';
import { PropertiesComponent } from './properties/properties.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/primeng';
import { Select2Module } from 'ng2-select2';
import { ComponentsModule } from '../../../../../components/component.module';
import { GroupComponent } from './group/group.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [BrowserModule, FormsModule, PaginatorModule, Select2Module, ComponentsModule, RouterModule],
  declarations: [ContactComponent, BlacklistComponent, PropertiesComponent, GroupComponent],
  exports: [ContactComponent, BlacklistComponent],
  providers: [],
})
export class ContactModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/contact.module.ts